export const BankAccount = {
  Babk: {
    value: 26,
  },
  Currencies: {
    value: 1213,
  },
};
